export default __webpack_public_path__ + "images/bathroom-heat-2.f04a023a52b04d74c37c2a03e8c133a7.png";